import { Client } from "../../service/client";

export class StripeApi {
  private client: Client;

  constructor(client: Client) {
    this.client = client;
  }

  async createSubscription(): Promise<string> {
    const response = await this.client.fetch(`/stripe/subscription/create`, {
      method: "POST",
    });

    const json = await response.json();

    return json.data.url;
  }

  async getSubscription() {
    const response = await this.client.fetch(`/stripe/subscription`);

    const json = await response.json();

    return json.data.subscription;
  }

  async manageSubscription(): Promise<string> {
    const response = await this.client.fetch(`/stripe/subscription/manage`);

    const json = await response.json();

    return json.data.url;
  }
}
